import React from 'react';

function formatMetricValue(amount, unit = '') {
  if (!Number.isFinite(amount)) {
    return 'No data';
  }

  if (unit === '$') {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: amount >= 1000 ? 0 : 1
    }).format(amount);
  }

  const decimals = Math.abs(amount) >= 100 ? 0 : 1;
  return `${amount.toFixed(decimals)}${unit ? ` ${unit}` : ''}`;
}

function KpiGapBadge({ actualValue, goalValue, unit = '' }) {
  const actual = Number(actualValue);
  const goal = Number(goalValue);

  if (!Number.isFinite(actual) || !Number.isFinite(goal)) {
    return (
      <div className="kpi-gap-badge neutral">
        <small>Gap to Goal</small>
        <strong>Not available</strong>
      </div>
    );
  }

  const difference = actual - goal;
  const isAtOrAboveGoal = difference >= 0;

  return (
    <div className={`kpi-gap-badge ${isAtOrAboveGoal ? 'good' : 'warning'}`}>
      <small>{isAtOrAboveGoal ? 'Above Goal By' : 'Gap to Goal'}</small>
      <strong>{formatMetricValue(Math.abs(difference), unit)}</strong>
    </div>
  );
}

export default KpiGapBadge;
